import styled from "styled-components";
import {StyledBaseProps} from "@betrue/shared/interfaces";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {Box} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import * as React from "react";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

interface LogoPlaceholderViewProps extends StyledBaseProps {
  chronos: number
}

export const LogoPlaceholderView = styled((props: LogoPlaceholderViewProps) =>
  (
    <Card className={props.className} sx={{height: 512, backgroundColor: '#EEE'}}>
      {props.chronos ? (<CardContent sx={{height: '100%', m: 0, p: 0, position: 'relative'}}>
        <Box sx={{width: '80%'}} className={'vertical-align'}>
          <LinearProgress/>
          <Typography variant={'caption'} component="div">
            {parseFloat(`${props.chronos}`).toFixed(2)}
          </Typography>
        </Box>
      </CardContent>) : (<CardContent sx={{height: '100%', m: 0, p: 0, position: 'relative'}}>
        <Typography variant={'caption'} className={'vertical-align'} component="div">
          Write your first prompt and click generate, to see results here.<br/>
          <AutoFixHighIcon/>
        </Typography>
      </CardContent>)}
    </Card>
  ))
  `
    & {
    }
  `
